import { render, staticRenderFns } from "./PDFDocument.vue?vue&type=template&id=ea51fa0a&"
import script from "./PDFDocument.vue?vue&type=script&lang=js&"
export * from "./PDFDocument.vue?vue&type=script&lang=js&"
import style0 from "./PDFDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports